import ReleaseApp from "./ReleaseApp.js";
export default ReleaseApp;
